export const GET_CONTACTS_REQUEST = 'GET_CONTACTS_REQUEST';
export const GET_TYPING_CONTACTS_REQUEST = 'GET_TYPING_CONTACTS_REQUEST';
export const GET_CONTACTS_SUCCESS = 'GET_CONTACTS_SUCCESS';
export const GET_CONTACTS_FAILURE = 'GET_CONTACTS_FAILURE';

export const GET_CONTACT_REQUEST = 'GET_CONTACT_REQUEST';
export const GET_CONTACT_SUCCESS = 'GET_CONTACT_SUCCESS';
export const GET_CONTACT_FAILURE = 'GET_CONTACT_FAILURE';

export const SET_CONTACTS = 'SET_CONTACTS';
export const SET_CONTACT = 'SET_CONTACT';

export const SUBMIT_CONTACT_REQUEST = 'SUBMIT_CONTACT_REQUEST';
export const SUBMIT_CONTACT_SUCCESS = 'SUBMIT_CONTACT_SUCCESS';
export const SUBMIT_CONTACT_FAILURE = 'SUBMIT_CONTACT_FAILURE';

export const getContactsRequest = (filters = {}) => ({
    type: GET_CONTACTS_REQUEST,
    payload: {
        filters
    }
});

export const getTypingContactsRequest = (filters = {}, alsoLookForClients) => ({
    type: GET_TYPING_CONTACTS_REQUEST,
    payload: {
        filters,
        alsoLookForClients
    }
});

export const getContactsSuccess = (contacts, total) => ({
    type: GET_CONTACTS_SUCCESS,
    payload: {
        contacts,
        total
    }
});

export const getContactsFailure = err => ({
    type: GET_CONTACTS_FAILURE,
    error: err
});

export const getContactRequest = (filters = {}, alsoLookForClients) => ({
    type: GET_CONTACT_REQUEST,
    payload: {
        filters,
        alsoLookForClients
    }
});

export const getContactSuccess = (contact) => ({
    type: GET_CONTACT_SUCCESS,
    payload: {
        contact
    }
});

export const getContactFailure = err => ({
    type: GET_CONTACT_FAILURE,
    error: err
});

export const setContacts = (contacts = [], total = 0) => ({
    type: SET_CONTACTS,
    payload: {
        contacts,
        total
    }
});

export const setContact = (contact = {}) => ({
    type: SET_CONTACT,
    payload: {
        contact
    }
});

export const submitContactsRequest = (contact, history) => ({
    type: SUBMIT_CONTACT_REQUEST,
    payload: { contact },
    history
});

export const submitContactsSuccess = contact => ({
    type: SUBMIT_CONTACT_SUCCESS,
    payload: {
        contact
    }
});

export const submitContactsFailure = err => ({
    type: SUBMIT_CONTACT_FAILURE,
    error: err
});
